<template>
  <div class="p-0 m-0 table-container">
    <div class="searchPanel">
      <div class="header-with-spinner">
        <h1>Wiadomości</h1>
        <div
          class="spinner-border text-secondary loader"
          role="status"
          v-show="loading === true"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="searchUserPanel">
        <form @submit.prevent="fetchRooms()">
          <div class="inputs df">
            <div class="datepickers df">
              <datepicker
                :monday-first="true"
                :language="pl"
                v-model="selectedDateFrom"
                name="dateFrom"
                :placeholder="'Data od'"
              ></datepicker>

              <datepicker
                :monday-first="true"
                :language="pl"
                v-model="selectedDateTo"
                name="dateTo"
                :placeholder="'Data do'"
              ></datepicker>
              <div class="clearDates">
                <button
                  class="btn btn-outline-dark clearButton"
                  @click="clearDates()"
                >
                  Wyczyść daty
                </button>
              </div>
            </div>

            <div class="inner-addon left-addon">
              <svg
                class="searchIcon margin"
                width="40"
                height="35"
                viewBox="0 0 30 29"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.3" clip-path="url(#clip0)">
                  <path
                    d="M26.8421 28.9995C26.5263 28.9995 26.2105 28.9995 25.8947 28.9995C25.5947 28.8 25.2474 28.6619 24.9947 28.4164C23.2579 26.7593 21.5368 25.0868 19.8158 23.4143C19.3263 22.954 19.0737 22.3249 19.3263 21.7418C19.6105 21.0974 19.3579 20.7598 18.9158 20.3915C18.6947 20.2074 18.4737 20.0233 18.3 19.7931C17.9211 19.3175 17.6053 19.3175 17.0684 19.655C11.8421 22.9693 4.76842 21.3582 1.56316 16.1566C0.742105 14.837 0.363158 13.3794 0 11.9064C0 11.1392 0 10.3873 0 9.62011C0.0473684 9.42064 0.126316 9.23652 0.157895 9.03704C0.852632 4.63334 4.32632 1.15027 8.92105 0.214293C13.2789 -0.675654 18.0316 1.24234 20.3842 4.95556C22.8316 8.83757 22.7368 12.7503 20.2895 16.6169C20.1474 16.8318 19.8316 17.0312 20.1474 17.3381C20.6368 17.8138 21.1105 18.2741 21.6 18.7497C21.7737 18.9185 21.9158 18.8418 22.1053 18.7804C23.0368 18.4122 23.7632 18.6884 24.4421 19.3482C25.9263 20.8212 27.4421 22.2788 28.9579 23.7212C29.3684 24.1201 29.7316 24.5344 30 25.0407C30 25.3476 30 25.6545 30 25.9614C29.1947 27.2042 28.1368 28.2169 26.8421 28.9995ZM11.0368 18.3815C15.4263 18.3968 18.9632 15.0058 18.9789 10.7556C18.9947 6.5053 15.4895 3.06826 11.1158 3.05292C6.69474 3.03757 3.15789 6.39789 3.12632 10.6482C3.09474 14.9445 6.6 18.3661 11.0368 18.3815Z"
                    fill="#090741"
                  />
                  <path
                    d="M15.3001 8.13255C15.2528 8.6389 15.0159 9.06853 14.4949 9.31404C13.9738 9.55954 13.437 9.55954 13.0107 9.20663C11.7001 8.10187 10.4528 8.13255 9.14223 9.22197C8.5896 9.68229 7.78434 9.52885 7.29486 9.0225C6.82118 8.5315 6.7896 7.7643 7.23171 7.21192C8.92118 5.06377 13.358 5.07911 15.0001 7.24261C15.1896 7.50345 15.3001 7.77964 15.3001 8.13255Z"
                    fill="#090741"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="30" height="29" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <input
                type="text"
                placeholder="Szukaj..."
                style="border-radius: 10px"
                class="form-control searchBlock"
                v-model="searchParam"
              />
            </div>
          </div>
        </form>
      </div>
    </div>

    <div
      class="header"
      :class="{ shrink: selectedUser }"
      v-if="rooms && rooms.length !== 0"
    >
      <div class="pl-2">
        <div class="flagsGroups">
          <i class="far fa-flag" @click="changeChatsGroup('NONE')"></i>
          <i
            @click="changeChatsGroup('ONE')"
            class="fas fa-flag"
            style="font-family: 'FontAwesome'; color: #fb8928"
          ></i>
          <i
            @click="changeChatsGroup('TWO')"
            class="fas fa-flag"
            style="font-family: 'FontAwesome'; color: #5196d3"
          ></i>
          <i
            @click="changeChatsGroup('THREE')"
            class="fas fa-flag"
            style="font-family: 'FontAwesome'; color: #888fd7"
          ></i>
          <i
            @click="changeChatsGroup('FOUR')"
            class="fas fa-flag"
            style="font-family: 'FontAwesome'; color: #ec1a6b"
          ></i>
          <i
            @click="changeChatsGroup('FIVE')"
            class="fas fa-flag"
            style="font-family: 'FontAwesome'; color: #009933"
          ></i>
        </div>
      </div>
      <div class="pagination">
        <pagination-inline
          :dispatchAction="`getRooms`"
          :onPage="this.rooms.on_page"
          :pageNumber="this.rooms.page_number"
          :total="this.rooms.total"
          :filterParam="this.selectedCategory"
          :searchParam="this.searchParam"
          v-model="loading"
        ></pagination-inline>
      </div>
      <div class="actionIcons">
        <div>
          <input
            type="checkbox"
            :value="allSelected"
            @change="selectUnselectAll()"
          />
        </div>
        <div @click="fetchRooms()">
          <i class="fas fa-sync-alt"></i>
        </div>
        <!-- <div><i class="far fa-trash-alt"></i></div>

        <div><i class="fas fa-check"></i></div> -->
      </div>
      <div class="filters p-0">
        <div
          :class="{ selectedHeader: selectedCategory === 'ALL' }"
          @click="handleFilters('ALL')"
        >
          <img src="../../icons/dotsAll.svg" /> Wszystkie
        </div>
        <div
          :class="{ selectedHeader: selectedCategory === 'READ' }"
          @click="handleFilters('READ')"
        >
          <img src="../../icons/readMessages.svg" /> Odczytane
        </div>
        <div
          :class="{ selectedHeader: selectedCategory === 'UNREAD' }"
          @click="handleFilters('UNREAD')"
        >
          <img src="../../icons/unreadMessages.svg" /> Nieodczytane
        </div>

        <v-swatches
          v-model="color"
          :swatches="colors"
          :swatch-size="20"
          :spacing-size="10"
          :inline="true"
        ></v-swatches>
      </div>
    </div>
    <table class="table">
      <tbody>
        <tr
          v-for="room in rooms.chats"
          :key="room.id"
          style="width: 100%"
          :class="room.last_message_unread ? 'unreadChat' : ''"
        >
          <td class="flags">
            <input type="checkbox" v-model="selectedChats" :value="room.id" />
            <i
              class="fas fa-flag flagIcon"
              style="color: #fb8928"
              v-if="room.chatGroup === 'ONE'"
            ></i>
            <i
              class="fas fa-flag flagIcon"
              style="color: #5196d3"
              v-if="room.chatGroup === 'TWO'"
            ></i>
            <i
              class="fas fa-flag flagIcon"
              style="color: #888fd7"
              v-if="room.chatGroup === 'THREE'"
            ></i>
            <i
              class="fas fa-flag flagIcon"
              style="color: #ec1a6b"
              v-if="room.chatGroup === 'FOUR'"
            ></i>
            <i
              class="fas fa-flag flagIcon"
              style="color: #009933"
              v-if="room.chatGroup === 'FIVE'"
            ></i>
          </td>
          <td style="width: 20%; font-weight: bold; text-align: left">
            {{ room.author_name }}
            {{
              room.author_last_name ? room.author_last_name.toUpperCase() : ""
            }}
          </td>
          <td style="width: 15%">
            {{ room.author_phone }}
          </td>
          <td
            style="width: 50%; cursor: pointer; text-align: left"
            @click="moveToChat(room.author_id)"
          >
            {{
              room.last_message_first_part.length > 75
                ? room.last_message_first_part.slice(0, 75) + "..."
                : room.last_message_first_part
            }}
          </td>
          <td style="width: 10%">
            {{ getFormattedDate(room.last_message_date) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";
import PaginationInline from "../../components/PaginationInline";
import axios from "../../axios";
import shared from "../../shared";
import Datepicker from "vuejs-datepicker";
import VSwatches from "vue-swatches";
import { pl } from "vuejs-datepicker/dist/locale";
import "vue-swatches/dist/vue-swatches.css";
import { convertDataToJsonAndAddToken } from "../../websockets";
export default {
  name: "rooms-component",
  components: { PaginationInline, VSwatches, Datepicker },
  data() {
    return {
      pl: pl,
      selectedDateFrom: null,
      selectedDateTo: null,
      onPage: 10,
      selectedCategory: "ALL",
      selectedGroup: "",
      allSelected: false,
      chatGroups: [],
      selectedChats: [],
      searchParam: "",
      color: "#f2f2f2",
      colors: [
        "#f2f2f2",
        "#FB8928",
        "#5196D3",
        "#888FD7",
        "#EC1A6B",
        "#009933",
      ],
      loading: false,
    };
  },

  watch: {
    async color() {
      this.loading = true;
      await this.handleGroupColor(this.color);
      await this.$store.dispatch("getRooms", {
        on_page: 20,
        page_number: 1,
        filter_param: this.selectedCategory,
        search_param: this.searchParam,
        group: this.selectedGroup,
      });
      this.loading = false;
    },
    selectedDateFrom: function () {
      this.fetchRooms();
    },
    selectedDateTo: function () {
      this.fetchRooms();
    },
  },

  methods: {
    clearDates() {
      (this.selectedDateFrom = null), (this.selectedDateTo = null);
      this.handleDispatchAction();
    },
    async handleGroupColor(color) {
      if (color === "#FB8928") {
        this.selectedGroup = "ONE";
      } else if (color === "#5196D3") {
        this.selectedGroup = "TWO";
      } else if (color === "#888FD7") {
        this.selectedGroup = "THREE";
      } else if (color === "#EC1A6B") {
        this.selectedGroup = "FOUR";
      } else if (color === "#009933") {
        this.selectedGroup = "FIVE";
      } else if (color === "#f2f2f2") {
        this.selectedGroup = null;
      }
    },

    selectUnselectAll() {
      if (this.allSelected) {
        this.selectedChats = [];
      } else {
        this.rooms.chats.forEach((chat) => {
          this.selectedChats.push(chat.id);
        });
      }
      this.allSelected = !this.allSelected;
    },
    changeChatsGroup(group) {
      axios
        .put(`/api/chat/groups?chat_group=${group}`, {
          chatIds: this.selectedChats,
        })
        .then(() => {
          this.fetchRooms();
          this.selectedChats = [];
        });
    },
    moveToChat(roomAuthorId) {
      this.$router.push(`/chat/${roomAuthorId}`);
    },
    async fetchRooms() {
      this.loading = true;
      await this.$store.dispatch("getRooms", {
        on_page: 20,
        page_number: 1,
        filter_param: this.selectedCategory,
        search_param: this.searchParam,
        group: this.selectedGroup,
        date_from: this.selectedDateFrom,
        date_to: this.selectedDateTo,
      });
      this.loading = false;
    },
    async handleFilters(selectedFilterValue) {
      this.loading = true;
      this.selectedCategory = selectedFilterValue;
      await this.$store.dispatch("getRooms", {
        on_page: 20,
        page_number: 1,
        filter_param: this.selectedCategory,
        search_param: this.searchParam,
        group: this.selectedGroup,
        date_from: this.selectedDateFrom,
        date_to: this.selectedDateTo,
      });
      this.loading = false;
    },
    getRoomClass(index) {
      if (index % 2 === 0) return "rooms-grey";
      return "rooms-white";
    },
    getFormattedDate(date) {
      moment.locale("pl");
      if (this.isToday(date)) {
        return moment(date).format("h:mm A");
      } else {
        return moment(date).format("DD MMM");
      }
    },
  },
  computed: {
    rooms() {
      return this.$store.getters.getRooms;
    },
    selectedUser() {
      return this.$store.getters.getSelectedUser;
    },
  },
  async created() {
    this.loading = true;
    const data = {
      page_number: 1,
      on_page: 20,
    };
    this.$socket.emit("ALL_CHATS_EVENT", convertDataToJsonAndAddToken(data));
    this.isToday = shared.isToday;
    // The socket has reconnection disabled, so after a dropped connection the emit above
    // never gets an answer - the initial list must not depend on it.
    await this.fetchRooms();

    await axios.get(`/api/chat/groups`).then((response) => {
      response.data.forEach((group) => {
        this.chatGroups.push({
          name: group,
          displayName: group,
        });
      });
    });
    this.loading = false;
  },
};
</script>

<style scoped>
.flagsGroups i {
  margin-right: 10px;
  font-size: 13px;
}
.df {
  display: flex;
}
.table-container {
  min-width: 100%;
}
.searchBlock {
  margin-top: 5px;
}
.header {
  padding: 0;
  display: flex;
  background: #f7f8f9;
  height: 60px;
  border-radius: 18px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  color: #93a3ad;
  -webkit-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  -moz-box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  box-shadow: 0px 0px 30px 5px rgba(176, 176, 176, 1);
  flex-wrap: wrap;
  font-size: 11px;
  justify-content: space-between;
}
.filters img {
  margin-right: 15px;
  height: 20px;
}
.header div {
  margin: 0 0 5px 0 !important;
  padding: 0 15px 0 15px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  min-height: 30px;
}
.selectedHeader {
  padding-top: 0 !important;
  margin: 5px 0 5px 0 !important;
  border-bottom: 4px solid #5196d3;
}
.datepickers {
  margin-right: 120px;
}
.actionIcons div {
  margin: 0;
  height: 20px;
  cursor: pointer;
  border: 1px solid #e5e5e9;
  padding: 5px 20px 5px 20px;
  color: #cccccf;
}
.margin {
  margin-top: 2px;
}
.actionIcons div:hover {
  color: #000;
}
.flags {
  display: flex;
  align-items: center;
  cursor: initial;
}
.flags i {
  margin-left: 15px;
}
.table tr {
  border: 0;
}
.shrink div {
  margin: 10px 0 10px 0;
  height: 40px;
  padding-top: 10px;
  padding-left: 25px;
  padding-right: 25px;
}
.shrink {
  justify-content: center;
  height: 160px;
}
@media screen and (max-width: 1100px) {
  .inputs {
    flex-direction: column;
  }
  .searchBlock {
    max-width: 40vw;
  }
}
@media screen and (max-width: 800px) {
  .datepickers {
    flex-direction: column;
  }
}
@media only screen and (max-width: 1240px) {
  .header div {
    margin: 10px 0 10px 0;
    height: 40px;
    padding-top: 10px;
  }
  .header {
    justify-content: center;
    height: 160px;
  }
}
@media only screen and (max-width: 1214px) {
  .shrink div {
    padding-left: 15px;
    padding-right: 15px;
  }
}

@media only screen and (max-width: 850px) {
  .header {
    flex-direction: column;
    font-size: 13px;
    height: 300px;
    justify-content: center;
  }
  .filters {
    flex-wrap: wrap;
  }
  .actionIcons {
    margin-top: 30px !important;
  }
}
@media only screen and (max-width: 590px) {
  .actionIcons {
    margin-top: 80px !important;
  }
  .header {
    height: 350px;
  }
  td {
    font-size: 9px !important;
  }
}
@media only screen and (max-width: 360px) {
  .actionIcons {
    margin-top: 150px !important;
  }
  .header {
    height: 450px;
  }
}
select {
  font-family: "FontAwesome", "Second Font name";
}
.flagIcon {
  font-size: 15px;
  margin-right: 10px;
}
.searchPanel h1 {
  margin-bottom: 0;
  margin-right: 20px;
}
.searchPanel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.searchUserPanel {
  display: flex;
  align-items: center;
}
.searchUserPanel input {
  border-radius: 50px !important;
  background: #f2f2f2;
  color: #090741;
  height: 32px;
  font-size: 13px;
}
.inner-addon {
  position: relative;
}

.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  pointer-events: none;
}

.left-addon input {
  padding-left: 30px;
}
select:focus {
  outline: none !important;
  background: white !important;
}

/* Remove default arrow */
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  margin-left: 32px;
}
.header-with-spinner {
  display: flex;
  align-items: center;
}
.unreadChat {
  background: rgba(234, 250, 250, 0.8);
}
</style>
